import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'

const AcknowledgmentsPage = () => (
  <Layout>
    <SEO title="Acknowledgments" keywords={['Acknowledgments', 'Agradecimientos', 'YHWH is my salvation',]}/>
    
    <h1><FormattedMessage id="acknowledgments" /></h1>
    <p>
        <FormattedMessage id="acknowledgments-p-1" />
    </p>

    <p>
        <FormattedMessage id="acknowledgments-p-2" />
    </p>

    <blockquote>
        <FormattedHTMLMessage id="acknowledgments-blockquote-1" />
    </blockquote>

    <p>
        <FormattedMessage id="acknowledgments-p-3" />
    </p>
    <ul>
        <li><a href="https://gatsbyjs.org" target="_blank" rel="noopener noreferrer">Gatsby</a></li>
        <li><a href="https://emotion.sh" target="_blank" rel="noopener noreferrer">Emotion</a></li>
        <li><a href="https://negomi.github.io/react-burger-menu/" target="_blank" rel="noopener noreferrer">react-burger-menu</a></li>
        <li><a href="https://www.audacityteam.org/" target="_blank" rel="noopener noreferrer">Audacity</a></li>
        <li><a href="https://surge.sh/" target="_blank" rel="noopener noreferrer">Surge</a></li>
        <li><a href="https://about.gitlab.com/" target="_blank" rel="noopener noreferrer">Gitlab</a></li>
    </ul>
  </Layout>
)

export default AcknowledgmentsPage
